import React, { useState } from "react";
import RefuseFromPolice from "./refuseFromPolice";
import ApproveFromPolice from "./approveFromPolice";

function PoliceReportDetailsModal({ selectedReport, adminName }) {
  const [zoomedImage, setZoomedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  const date = new Date(selectedReport?.date);
  const formattedDate = date.toLocaleString("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });

  const combinedMedia = [
    ...(selectedReport?.photos || []),
    ...(selectedReport?.videos || []),
  ];

  // const isVideo = (media) =>
  //   media.endsWith(".mp4") || media.endsWith(".avi") || media.endsWith(".mov");

    const isVideo = (media) => {
  if (!media || typeof media !== "string") return false; // ✅ guard
  const lower = media.split("?")[0].toLowerCase();      // remove query params
  return lower.endsWith(".mp4") || lower.endsWith(".avi") || lower.endsWith(".mov");
};

  // Carousel navigation
  const prevSlide = () => {
    setCurrentIndex((currentIndex - 1 + combinedMedia.length) % combinedMedia.length);
  };

  const nextSlide = () => {
    setCurrentIndex((currentIndex + 1) % combinedMedia.length);
  };

  // Zoom navigation
  const prevZoomed = () => {
    const newIndex = (currentIndex - 1 + combinedMedia.length) % combinedMedia.length;
    setCurrentIndex(newIndex);
    if (!isVideo(combinedMedia[newIndex])) {
      setZoomedImage(combinedMedia[newIndex]);
    }
  };

  const nextZoomed = () => {
    const newIndex = (currentIndex + 1) % combinedMedia.length;
    setCurrentIndex(newIndex);
    if (!isVideo(combinedMedia[newIndex])) {
      setZoomedImage(combinedMedia[newIndex]);
    }
  };

  // Watermark JSX
  const Watermark = () => (
    adminName?.trim() ? (
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center select-none">
        <span
          className="font-bold text-white/30 break-words"
          style={{
            transform: "rotate(-45deg)",
            userSelect: "none",
            width: "90%",
            textAlign: "center",
            fontSize: "clamp(14px, 4vw, 50px)",
            lineHeight: "1.1",
            wordBreak: "break-word",
          }}
        >
          {adminName}
        </span>
      </div>
    ) : null
  );

  return (
    <>
      <input type="checkbox" id="my-modal-5" className="modal-toggle" />
      <div className="modal">
        <div className="modal-box bottom-0 w-11/12 max-w-5xl bg-white p-0 pe-6 ps-4">
          {/* Header */}
          <div className="sticky top-0 bg-white pt-4">
            <h3 className="flex justify-center text-lg font-bold text-brand-500">
              Detajet e Raportit #{selectedReport?.reportName}
            </h3>
            <label
              htmlFor="my-modal-5"
              className="btn btn-circle btn-sm absolute right-3 top-3 bg-white text-brand-700 hover:text-white"
              onClick={() => setZoomedImage(null)}
            >
              ✕
            </label>
            <hr className="mt-2" />
          </div>

          {/* Report Info */}
          <div className="mt-4 space-y-3 px-2">
            <p>
              <span className="font-bold">Qyteti:</span>{" "}
              {selectedReport?.address
                ? (() => {
                    const gpsMatch = selectedReport.address.match(/\(([^)]+)\)/);
                    const cityName = selectedReport.address.split("(")[0].trim();

                    if (gpsMatch && gpsMatch[1]) {
                      const [lat, lng] = gpsMatch[1].split(",").map((x) => x.trim());
                      const googleMapsUrl = `https://www.google.com/maps?q=${lat},${lng}`;
                      return (
                        <>
                          <span>{cityName} </span>
                          <span>(</span>
                          <a
                            href={googleMapsUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="cursor-pointer font-semibold text-blue-600 underline"
                            title="Shiko lokacionin në Google Maps"
                          >
                            {lat}, {lng}
                          </a>
                          <span>)</span>
                        </>
                      );
                    }
                    return <span>{selectedReport.address}</span>;
                  })()
                : "Unknown"}
            </p>
            <p>
              <span className="font-bold">Kategoria:</span> {selectedReport?.category}
            </p>
            <p>
              <span className="font-bold">Data:</span> {formattedDate}
            </p>
            <p>
              <span className="font-bold">Përshkrimi:</span> {selectedReport?.textContent}
            </p>
            {/* {selectedReport?.targetCars?.trim() && (
              <p>
                <span className="font-bold">Targat e veturës:</span> {selectedReport.targetCars}
              </p>
            )} */}
          </div>

          {/* Media Carousel */}
          {combinedMedia.length > 0 && (
            <div className="relative mx-auto mt-6 flex max-w-2xl items-center justify-center">
              <div className="relative inline-block">
                {isVideo(combinedMedia[currentIndex]) ? (
                  <video
                    src={combinedMedia[currentIndex]}
                    className="max-h-80 w-auto max-w-full rounded-lg object-contain shadow"
                    controls
                  />
                ) : (
                  <img
                    src={combinedMedia[currentIndex]}
                    className="max-h-80 w-auto max-w-full cursor-pointer rounded-lg object-contain shadow transition hover:scale-105"
                    alt={`media-${currentIndex + 1}`}
                    onClick={() => setZoomedImage(combinedMedia[currentIndex])}
                  />
                )}

                {/* Watermark overlay */}
                <Watermark />
              </div>

              {combinedMedia.length > 1 && (
                <>
                  <button
                    onClick={prevSlide}
                    className="btn btn-circle absolute left-2 bg-white text-brand-700 shadow-md hover:text-white"
                  >
                    ❮
                  </button>
                  <button
                    onClick={nextSlide}
                    className="btn btn-circle absolute right-2 bg-white text-brand-700 shadow-md hover:text-white"
                  >
                    ❯
                  </button>
                </>
              )}
            </div>
          )}

          {/* Footer */}
          <footer className="modal-action sticky bottom-0 bg-white pb-4 pt-2">
            <hr className="mb-2" />
            <label htmlFor="my-modal-5" className="btn border-0 bg-white text-brand-700 hover:text-white">
              Kthehu
            </label>
            <label htmlFor="my-modal-6" className="btn border-0 bg-red-500 text-white hover:bg-red-600">
              Refuzo
            </label>
            <label htmlFor="my-modal-7" className="btn border-0 bg-brand-500 text-white hover:bg-brand-700">
              Aprovo
            </label>
            <RefuseFromPolice id={selectedReport?.id} />
            <ApproveFromPolice id={selectedReport?.id} />
          </footer>
        </div>
      </div>

      {/* Fullscreen Image Viewer */}
      {zoomedImage && (
        <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-black bg-opacity-90">
          <button
            className="absolute right-4 top-4 text-3xl text-white"
            onClick={() => setZoomedImage(null)}
          >
            ✕
          </button>
          {combinedMedia.length > 1 && (
            <>
              <button onClick={prevZoomed} className="absolute left-5 text-4xl text-white">
                ❮
              </button>
              <button onClick={nextZoomed} className="absolute right-5 text-4xl text-white">
                ❯
              </button>
            </>
          )}
          <div className="relative inline-block">
            <img
              src={zoomedImage}
              className="max-h-full max-w-full rounded-lg object-contain transition-transform duration-200 hover:scale-110"
              alt="Zoomed Media"
            />
            <Watermark />
          </div>
        </div>
      )}
    </>
  );
}

export default PoliceReportDetailsModal;
